export default __webpack_public_path__ + "b6944870e500b22367ff2efcefc26c5b.png";